// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box__preview--common {\n  min-width: 170px;\n}\n.box__preview--common--title {\n  margin-left: 5px;\n  min-width: -moz-max-content;\n  min-width: max-content;\n  font-size: 12px;\n}\n.box__preview--common--content {\n  margin-left: 10px;\n  font-size: 12px;\n  margin-bottom: 0;\n}", ""]);
// Exports
module.exports = exports;
